import React from 'react';
import { useViewlogies } from 'context';
import { hexToRGBA, capitalize } from 'utils';
import './navigation.scss';
import { FormattedMessage } from 'react-intl';
import m from './messages';
import Header from 'components/ClientHeader';
import Footer from 'components/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-regular-svg-icons';

const Navigation = ({ tabs, activeTab, onTabSelect }) => {
    const {
        event: { color },
        event: { firstName, lastName },
    } = useViewlogies();

    const selectedStyle = {
        color,
    };

    return (
        <div className="sidebar" style={{ backgroundColor: hexToRGBA(color, 0.25) }}>
            <div className="menu">
                <Header />
                <h2>{`${capitalize(firstName)} ${capitalize(lastName)}`}</h2>
                {tabs.map(tab => (
                    <button
                        key={tab}
                        onClick={() => onTabSelect(tab)}
                        className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                        style={activeTab === tab ? selectedStyle : {}}
                    >
                        <FormattedMessage {...m[tab]} />
                    </button>
                ))}
            </div>

            <div className="nav-footer">
                <button
                    onClick={() => onTabSelect('helpCenter')}
                    // onClick={() => console.log('Help Center clicked')}
                    className={`tab-button help-center-button ${activeTab === 'helpCenter' ? 'helpActive' : ''}`}
                >
                    <FontAwesomeIcon icon={faComment} role="button" className="icon" />
                    <FormattedMessage {...m.helpCenter} />
                </button>
                <Footer />
            </div>
        </div>
    );
};

export default Navigation;
